import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/page/Home.vue';
import Product from '@/views/page/product/Product.vue';
import AddEditProduct from '@/views/page/product/AddEditProduct.vue';
import Customer from '@/views/page/customer/Customer.vue';
import CustomerDetail from '@/views/page/customer/CustomerDetail.vue';
import Reminder from '@/views/page/reminder/Reminder.vue';
import Setting from '@/views/page/Setting.vue';
import Transaction from '@/views/page/transaction/Transaction.vue';
import TransactionTemp from '@/views/page/transaction/Transaction.vue';
import AddTransaction from '@/views/page/transaction/AddEditTransaction.vue';
import Branch from '@/views/page/Branch.vue';
import UserActivities from '@/views/page/UserActivities.vue';
import Login from '@/views/page/auth/Login.vue';
import Coupon from '@/views/page/coupon/Coupon.vue';
import Category from '@/views/page/Category.vue';
import { requireAuth } from '@/middleware/auth';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      page_title: "Login",
      login_page: true
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: requireAuth,
    meta: {
      page_title: "Hi Michelle!"
    }
  },
  {
    path: '/reminder',
    name: 'Reminder',
    component: Reminder,
    beforeEnter: requireAuth,
  },
  {
    path: '/transaction',
    name: 'Transaction',
    component: Transaction,
    beforeEnter: requireAuth,
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: TransactionTemp,
    beforeEnter: requireAuth,
  },
  {
    path: '/transaction/new',
    name: 'AddTransaction',
    component: AddTransaction,
    beforeEnter: requireAuth,
  },
  {
    path: '/customer',
    name: 'Customer',
    component: Customer,
    beforeEnter: requireAuth,
  },
  {
    path: '/customer/detail/:id',
    name: 'CustomerDetail',
    props: true,
    component: CustomerDetail,
    beforeEnter: requireAuth,
  },
  {
    path: '/product',
    name: 'Product',
    component: Product,
    beforeEnter: requireAuth,
  },
  {
    path: '/product/new',
    name: 'AddProduct',
    component: AddEditProduct,
    beforeEnter: requireAuth,
  },
  {
    path: '/product/edit/:id',
    name: 'EditProduct',
    component: AddEditProduct,
    props:true,
    beforeEnter: requireAuth,
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
    beforeEnter: requireAuth,
  },
  {
    path: '/setting/coupon',
    name: 'Coupon',
    component: Coupon,
    beforeEnter: requireAuth,
  },
  {
    path: '/setting/category',
    name: 'Category',
    component: Category,
    beforeEnter: requireAuth,
  },
  {
    path: '/setting/branch',
    name: 'Branch',
    component: Branch,
    beforeEnter: requireAuth,
  },
  {
    path: '/setting/user-activities',
    name: 'UserActivities',
    component: UserActivities,
    beforeEnter: requireAuth,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router